import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ToastService } from './toast.service';
import { ToastItem } from './toast.model';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'containerClass()',
    'aria-live': 'polite',
    'aria-atomic': 'false',
  },
})
export class ToastComponent {
  readonly toastService = inject(ToastService);

  readonly toasts = computed(() => this.toastService.toasts());

  readonly containerClass = computed(() => {
    const baseClass =
      'pointer-events-none fixed z-[1000] flex w-full max-w-[420px] flex-col gap-3 p-4 sm:max-w-[460px] sm:p-5';

    switch (this.toastService.position()) {
      case 'top-left':
        return `${baseClass} left-0 top-0 items-start`;
      case 'bottom-right':
        return `${baseClass} bottom-0 right-0 items-end`;
      case 'bottom-left':
        return `${baseClass} bottom-0 left-0 items-start`;
      case 'top-right':
      default:
        return `${baseClass} right-0 top-0 items-end`;
    }
  });

  onMouseEnter(toast: ToastItem): void {
    this.toastService.pause(toast.id);
  }

  onMouseLeave(toast: ToastItem): void {
    this.toastService.resume(toast.id);
  }

  close(toast: ToastItem): void {
    this.toastService.dismiss(toast.id);
  }

  trackByToastId(_index: number, toast: ToastItem): string {
    return toast.id;
  }
}
